import { jsx as _jsx } from "react/jsx-runtime";
import { renderXml } from './renderXml';
import { renderJson } from './renderJson';
import { renderTs } from './renderTs';
import { renderCs } from './renderCs';
export function Code(props) {
    const renderedCode = renderSource(props.type ?? 'json', props.source ?? '');
    return (_jsx("pre", { children: _jsx("code", { children: renderedCode }) }));
}
function renderSource(type, source) {
    switch (type) {
        case 'xml':
            return renderXml(source);
        case 'json':
            return renderJson(source);
        case 'ts':
            return renderTs(source);
        case 'cs':
            return renderCs(source);
        default:
            return source;
    }
}
